import { useEffect } from 'react'

import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

import Brand from 'helpers/brand'

const useSiteMessages = ({ listForAllBrands = false, getPublishedOnly = false, refreshTimestamp = false } = {}) => {
  const {
    siteMessages,
    setSiteMessages,
    areSiteMessagesLoaded,
    setAreSiteMessagesLoaded
  } = useStoreContext()

  useEffect(() => {
    const brands = listForAllBrands ? Brand.allBrandsOfCurrentBusinessUnit() : Brand.current()

    Api.SiteMessages.list(brands, getPublishedOnly)
      .then((res) => {
        setSiteMessages(res)
        setAreSiteMessagesLoaded(true)
      })
      .catch(() => {
        setSiteMessages(null)
        setAreSiteMessagesLoaded(true)
      })
  }, [getPublishedOnly, refreshTimestamp]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    siteMessages,
    areSiteMessagesLoaded
  }
}

export default useSiteMessages
